exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-alerts[data-v-0ea4f378]{background:rgba(0,0,0,.8);color:#fff;padding:1rem;width:100%}", ""]);

// exports
